var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container mt-5"},[(_vm.internalList)?_c('AccountInternalTxnsTable',{attrs:{"address":_vm.address,"data":_vm.internalList,"page":'showTop'}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }